import { render, staticRenderFns } from "./AcoesProcessoEdocs.vue?vue&type=template&id=f1b1fa52"
import script from "./AcoesProcessoEdocs.vue?vue&type=script&lang=js"
export * from "./AcoesProcessoEdocs.vue?vue&type=script&lang=js"
import style0 from "./AcoesProcessoEdocs.vue?vue&type=style&index=0&id=f1b1fa52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports